import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { UsersSummary } from '../users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getGuestsSummaryKey = 'get-guests-summary';

export const useGuestsSummaryHook = (
  options?: UseQueryOptions<UsersSummary, TQueryError>
): UseQueryResult<UsersSummary, TQueryError> => {
  const { getGuestUsersSummary } = useUsersService();

  return useQuery<UsersSummary, TQueryError>({
    queryKey: [getGuestsSummaryKey],
    queryFn: () => getGuestUsersSummary(),
    enabled: true,
    ...options,
  });
};
